export default __webpack_public_path__ + "static/media/White-sallallahu-alaihi-wasallam.2a074d38.png";